import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        <h1>TechVisor</h1>
        <p>@All Rights Reserved</p>
      </div>

      <div>
        <h5>Follow Us</h5>
        <div>
          <a href="link" target={"_blank"}>Linkedin</a>
          <a href="link" target={"_blank"}>Github</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
